import Immutable from 'seamless-immutable';

import { stringArrayToObject } from './utils';

/* ------------- Alert actions ------------- */
export const actions = stringArrayToObject(['OPEN_MODAL', 'CLOSE_MODAL'], '@@ALERT');

export const actionCreators = {
  openModal(options) {
    return {
      type: actions.OPEN_MODAL,
      payload: { ...options }
    };
  },
  closeModal() {
    return {
      type: actions.CLOSE_MODAL
    };
  }
};

/* ------------- Alert reducer ------------- */

const defaultState = {
  alertModalOpen: false,
  alertModalTitle: null,
  alertModalContent: null
};

/* eslint-disable complexity */
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.OPEN_MODAL: {
      return Immutable.merge(state, {
        alertModalOpen: true,
        alertModalTitle: action.payload.title,
        alertModalContent: action.payload.content,
        alertOnDismiss: action.payload.onDismiss
      });
    }
    case actions.CLOSE_MODAL: {
      return Immutable.merge(state, {
        alertModalOpen: false,
        alertModalTitle: null,
        alertModalContent: '',
        alertOnDismiss: null
      });
    }
    default: {
      return state;
    }
  }
}
/* eslint-enable complexity */
